module.exports = __webpack_public_path__ + "media/2-52.870dd96a.wav";